export function getSecondsFromThrottleMsg(message: string) {
  const digits = (message.match(/\d/g) || []).join('');
  return Number(digits);
}
